import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import PublicIcon from '@mui/icons-material/Public';
import { Typography } from '@mui/material';


const Clock = () => {

    const [time, setTime] = useState("");


    useEffect(() => {
        const handleTime = () => {
            const date = new Date();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const seconds = date.getSeconds()
            setTime(hour + ":" + minute + ":" + seconds);

        }
        const interval = setInterval(handleTime, 1000)

        return () => { clearInterval(interval) }
    }, [])

    return (
        <Box display="flex" alignItems="center">
            <PublicIcon sx={{ color: 'text.secondary', mr: 0.5 }} fontSize="small" />
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 72, fontVariantNumeric: 'tabular-nums' }}>
                {time}
            </Typography>
        </Box>
    )
}

export default Clock;